{
  "cards": {
    "continue": "Continuar",
    "start": "Começar",
    "viewCourse": "Ver Curso",
    "previous": "Anterior",
    "next": "Próximo",
    "goToSlide": "Ir para slide {{number}}",
    "banner": "Banner",
    "percentComplete": "{{percent}}% completo",
    "percentCompleted": "{{percent}}% concluído",
    "access": "Acessar",
    "previousBanner": "Banner anterior",
    "nextBanner": "Próximo banner",
    "new": "Novo",
    "viewDetails": "Ver detalhes",
    "review": "Revisar",
    "locked": "Bloqueado",
    "completed": "Concluído",
    "complete": "Completo",
    "restrictedAccess": "Acesso restrito",
    "scrollLeft": "Scroll para a esquerda",
    "scrollRight": "Scroll para a direita",
    "buy": "Comprar",
    "unlock": "Desbloquear acesso"
  },
  "courseSections": {
    "relatedCourses": "Cursos relacionados",
    "noCourseSelected": "Nenhum curso selecionado",
    "modules": "Módulos",
    "noModuleSelected": "Nenhum módulo selecionado",
    "dragToReorder": "Arrastar para reordenar",
    "progress": "Progresso",
    "viewTrail": "Ver Trilha",
    "lessonCount_one": "{{count}} aula",
    "lessonCount_zero": "{{count}} aulas",
    "lessonCount_other": "{{count}} aulas"
  },
  "home": {
    "greeting": {
      "morning": "Bom dia, <name>{{name}}</name>",
      "afternoon": "Boa tarde, <name>{{name}}</name>",
      "evening": "Boa noite, <name>{{name}}</name>"
    },
    "defaultName": "Aluno",
    "loading": "Carregando...",
    "quickLinks": {
      "courses": {
        "title": "Meus Cursos",
        "description": "Acesse todos os seus cursos disponíveis"
      },
      "ranking": {
        "title": "Ranking",
        "description": "Veja sua posição e conquistas"
      },
      "community": {
        "title": "Comunidade",
        "description": "Conecte-se com outros alunos"
      },
      "certificates": {
        "title": "Certificados",
        "description": "Baixe seus certificados de conclusão"
      }
    },
    "subtitle": {
      "continue": "Continue de onde parou",
      "explore": "Explore seus cursos",
      "start": "Comece sua jornada de aprendizado"
    },
    "stats": {
      "courses": "cursos",
      "inProgress": "em andamento",
      "completed": "concluídos"
    },
    "continueWatching": "Continue Assistindo",
    "continueLesson": "Aula \"{{title}}\" · parou em {{time}}",
    "quickAccess": "Acesso Rápido",
    "continueLearning": "Continue Aprendendo",
    "viewAll": "Ver todos"
  },
  "courses": {
    "loading": "Carregando cursos...",
    "title": "Cursos",
    "subtitle": "Explore todos os cursos disponíveis na plataforma",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "startCourse": "Iniciar curso",
    "emptyTitle": "Nenhum curso encontrado",
    "emptyDescription": "Em breve teremos novidades!"
  },
  "course": {
    "notFoundTitle": "Curso não encontrado",
    "notFoundDescription": "O curso que você está procurando não existe.",
    "backToCourses": "Voltar para cursos",
    "lockedTitle": "Conteúdo bloqueado",
    "lockedDescription": "Você ainda não tem acesso a este curso. Garanta sua vaga para liberar todas as aulas.",
    "lockedNoCheckout": "Este curso ainda não está disponível para compra. Fale com o produtor para liberar o acesso.",
    "buyNow": "Comprar agora",
    "changePlanTitle": "Planos deste curso",
    "changePlanDescription": "Quer trocar de plano? Ao assinar outro plano, o atual é encerrado e o seu acesso continua.",
    "choosePlan": "Escolher este plano",
    "fromPrice": "a partir de {{price}}"
  },
  "trail": {
    "startHere": "Comece aqui!",
    "backToCourse": "Voltar ao curso",
    "title": "Trilha de Aprendizado",
    "modulesProgress_one": "<bold>{{completed}}</bold>/{{count}} módulo",
    "modulesProgress_zero": "<bold>{{completed}}</bold>/{{count}} módulos",
    "modulesProgress_other": "<bold>{{completed}}</bold>/{{count}} módulos",
    "start": "Inicio da Trilha",
    "completed": "Trilha Concluida!",
    "end": "Fim da Trilha",
    "emptyTitle": "Nenhum módulo disponível",
    "emptyDescription": "Este curso ainda não possui módulos cadastrados."
  },
  "ranking": {
    "loading": "Carregando ranking...",
    "title": "Ranking",
    "subtitle": "Conquiste pontos, suba de nível e destaque-se entre os melhores",
    "rankBadge": "#{{rank}} no ranking",
    "howItWorks": "Como funciona?",
    "stats": {
      "totalXp": "XP Total",
      "accumulatedPoints": "pontos acumulados",
      "level": "Nível",
      "defaultLevel": "Iniciante",
      "position": "Posição",
      "overallRanking": "no ranking geral",
      "streak": "Sequência",
      "consecutiveDays": "dias consecutivos"
    },
    "achievements": {
      "title": "Conquistas",
      "unlocked": "{{unlocked}} de {{total}} desbloqueadas"
    },
    "leaderboard": {
      "title": "Leaderboard",
      "subtitle": "Os melhores alunos da plataforma"
    },
    "periods": {
      "all": "Geral",
      "monthly": "Mensal",
      "weekly": "Semanal"
    },
    "anonymous": "Anônimo",
    "you": "Você",
    "pagination": {
      "previous": "Anterior",
      "next": "Próxima",
      "pageOf": "{{page}} de {{total}}"
    },
    "empty": {
      "title": "Ranking vazio",
      "description": "Complete aulas para ganhar pontos e aparecer aqui!"
    },
    "emptyPeriod": {
      "title": "Ninguém pontuou neste período ainda",
      "description": "Complete aulas para ganhar pontos e aparecer aqui!"
    },
    "explanationTitle": "Como funciona a Gamificação?",
    "howItWorksModal": {
      "xpPerAction": "XP por ação",
      "xpPerLevel": "XP por nível",
      "learning": "Aprendizado",
      "community": "Comunidade",
      "level": "Nível",
      "fromXp": "A partir de {{xp}}",
      "dailyLimit": "(até {{count}} por dia)",
      "courseProgress": "Chegou a {{percent}}% do curso"
    }
  },
  "achievements": {
    "title": "Conquistas",
    "subtitle": "Acompanhe seu progresso e desbloqueie conquistas épicas",
    "stats": {
      "points": "Pontos",
      "defaultLevel": "Iniciante",
      "streak": "Sequência",
      "ranking": "Ranking"
    },
    "levelProgress": {
      "title": "Progresso do Nivel",
      "level": "Nivel {{level}}: {{name}}",
      "pointsNeeded": "Faltam <highlight>{{points}}</highlight> pontos para o próximo nível"
    },
    "tabs": {
      "achievements": "Conquistas",
      "ranking": "Ranking"
    },
    "unlockedSummary": "<highlight>{{unlocked}}</highlight> de <mono>{{total}}</mono> conquistas desbloqueadas",
    "leaderboard": {
      "title": "Top 10 - Ranking Geral",
      "defaultUser": "Usuário",
      "empty": "Nenhum usuário no ranking ainda.",
      "yourPosition": "Sua posição"
    }
  },
  "community": {
    "title": "Comunidade",
    "subtitle": "Comunidade e Interação",
    "enterDescription": "Tire dúvidas, compartilhe o que está aprendendo e converse com os outros alunos. Seu acesso é feito automaticamente com a conta da área de membros.",
    "enterButton": "Entrar na comunidade",
    "entering": "Entrando...",
    "enterError": "Não foi possível entrar na comunidade. Tente novamente.",
    "unavailable": "A comunidade ainda não está disponível."
  },
  "certificates": {
    "title": "Meus Certificados",
    "subtitle": "Seus certificados de conclusão de cursos",
    "completionCertificate": "Certificado de Conclusão",
    "issuedOn": "Emitido em {{date}}",
    "view": "Ver certificado",
    "download": "Baixar",
    "validate": "Validar certificado",
    "emptyTitle": "Nenhum certificado ainda",
    "emptyDescription": "Complete seus cursos para receber certificados de conclusão.",
    "viewMyCourses": "Ver meus cursos",
    "verificationTitle": "Verificação de Autenticidade",
    "verificationDescription": "Todos os certificados possuem um código único de verificação. Qualquer pessoa pode verificar a autenticidade do seu certificado através da nossa página de verificação.",
    "verifyLink": "Verificar um certificado →",
    "pendingTitle": "Cursos concluídos",
    "pendingDescription": "Você concluiu estes cursos. Gere o seu certificado.",
    "generate": "Gerar certificado",
    "generated": "Certificado gerado!",
    "generateError": "Não foi possível gerar o certificado. Tente novamente.",
    "notAvailableYet": "O certificado deste curso ainda não foi liberado pela escola. Tente novamente mais tarde."
  },
  "profile": {
    "toasts": {
      "nameRequired": "O nome não pode estar vazio",
      "profileUpdated": "Perfil atualizado com sucesso!",
      "profileUpdateError": "Erro ao atualizar perfil",
      "unsupportedImageFormat": "Formato de imagem não suportado. Use JPG, PNG, GIF ou WebP.",
      "imageTooLarge": "A imagem deve ter no máximo 5MB",
      "imageUrlMissing": "URL da imagem não retornada",
      "photoUpdated": "Foto atualizada com sucesso!",
      "photoUpdateError": "Erro ao atualizar foto. Tente novamente."
    },
    "title": "Minha Conta",
    "subtitle": "Administre informações e configurações do seu perfil",
    "level": "Nível",
    "avatar": {
      "save": "Salvar foto",
      "change": "Trocar foto"
    },
    "personal": {
      "title": "Dados Pessoais",
      "description": "Preencha seus principais dados",
      "fullName": "Nome completo *",
      "fullNamePlaceholder": "Seu nome completo",
      "email": "Email",
      "emailReadOnly": "O email não pode ser alterado",
      "phone": "Celular/WhatsApp",
      "birthDate": "Data de nascimento",
      "occupation": "Ocupação",
      "occupationPlaceholder": "Ex: Desenvolvedor Full Stack",
      "bio": "Bio (opcional)",
      "bioPlaceholder": "Fale um pouco sobre você..."
    },
    "address": {
      "title": "Endereço",
      "zipCode": "CEP",
      "zipCodePlaceholder": "00000-000",
      "state": "Estado",
      "statePlaceholder": "SP",
      "city": "Cidade",
      "cityPlaceholder": "São Paulo",
      "neighborhood": "Bairro",
      "street": "Rua, Avenida...",
      "number": "Número",
      "complement": "Complemento",
      "complementPlaceholder": "Apto, Sala..."
    },
    "social": {
      "title": "Redes Sociais",
      "usernamePlaceholder": "@seuusuario"
    },
    "customFields": {
      "title": "Informações Adicionais",
      "selectPlaceholder": "Selecione"
    },
    "saving": "Salvando...",
    "saveChanges": "Salvar alterações"
  }
}
